// src/components/FeatureFlagRoute.tsx
import React from 'react';

import { Route, RouteProps } from 'react-router-dom';
import RedirectToLogin from 'src/components/RedirectToLogin';
import { useAuthContext } from 'src/context/AuthContextProvider';
import NotFound from 'src/pages/404';
import { FeatureFlags } from 'src/types/feature-flag';
import { useFeatureFlag } from 'src/utils/hooks/featureFlag';

interface FeatureFlagRouteProps extends RouteProps {
  featureFlag: keyof FeatureFlags;
  redirectTo?: string;
}

const FeatureFlagRoute: React.FC<FeatureFlagRouteProps> = ({
  featureFlag,
  redirectTo = '/plataforma',
  ...routeProps
}) => {
  const { auth } = useAuthContext();
  const isActive = useFeatureFlag(featureFlag);

  if (!auth.isLoggedIn) {
    return <RedirectToLogin />;
  }

  if (!isActive) {
    return <NotFound />;
  }

  return <Route {...routeProps} />;
};

export default FeatureFlagRoute;
